import React from 'react'
import { Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import { sortBy, values } from 'lodash'

import Button from '../components/Button.jsx'
import { getText, getTextWithTokens } from '../lib/text.js'
import { createTag, removeTag } from '../ducks/tags';
import { getTagsForType } from '../selectors/index';

import "./tags.less"

type Props = {
  onRemove: string => void,
  onCreate: string => void,
  onClose: () => void,
  tags: Object,
  tagType: string
}

const ModalTagsEditor = (props: Props) => (
  <Modal show onHide={() => props.onClose()}>
    <Modal.Header>
      <Modal.Title>
        {getText("Lista de etiquetas")}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="ModalTagsEditorBody">
      <ul>
        {
          sortBy(
            values(props.tags), 
            tag => (tag.fixed ? "a" : "z") + tag.name
          )
            .map(tag => (
              <li key={tag._id}>
                {tag.name}
                {
                  !tag.fixed && (
                    <Button
                      bsSize="xsmall"
                      style={{ color: "red", borderWidth: 0, margin: 0 }}
                      glyph="remove"
                      onClick={() => {
                        if (confirm(getTextWithTokens(`delete_tag`, [tag.name || ""]))) {
                          props.onRemove(tag._id)
                        }
                      }}
                    />
                  )
                }
              </li>
            ))
        }
      </ul>
      <Button
        bsStyle="success"
        onClick={() => {
          const text = prompt("Introduce la nueva etiqueta")
          if (text != null) {
            props.onCreate(text.toUpperCase(), props.tagType)
          }
        }}
        style={{marginLeft: "20"}}
      >
        {getText("Añadir etiqueta")}
      </Button>
    </Modal.Body>
    <Modal.Footer>
      <Button
        bsStyle="info"
        onClick={() => { props.onClose() }}
      >
        {getText("Aceptar")}
      </Button>
    </Modal.Footer>
  </Modal>
)

const mapStateToProps = (state, props) => ({
  tags: getTagsForType(state, props)
})

const mapDispatchToProps = dispatch => ({
  onCreate: (name, tagType) => dispatch(createTag({ name, tagType })),
  onRemove: _id => dispatch(removeTag(_id))
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalTagsEditor)
